import { render, staticRenderFns } from "./TimelineEvent.vue?vue&type=template&id=12b32d8f&scoped=true&"
import script from "./TimelineEvent.vue?vue&type=script&lang=js&"
export * from "./TimelineEvent.vue?vue&type=script&lang=js&"
import style0 from "./TimelineEvent.vue?vue&type=style&index=0&id=12b32d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b32d8f",
  null
  
)

export default component.exports